import { environment } from '$env/environment';
import { Injectable } from '@angular/core';
import { detect } from 'detect-browser';

const FUTURE_MIN_VERSIONS = {
  chrome: 90,
  firefox: 88,
  safari: 14,
  ios: 14, // Safari на iOS
  'edge-chromium': 90,
  edge: 90,
  opera: 76,
};

@Injectable({
  providedIn: 'root',
})
export class BrowserDetectService {
  public readonly detectionInfo = detect();

  public get isIE() {
    return this.detectionInfo && this.detectionInfo.name === 'ie';
  }

  constructor() {
    if (!environment.production) {
      console.log(this.detectionInfo);
    }
  }

  isDeprecatingSoon(): boolean {
    if (!this.detectionInfo || !this.detectionInfo.version) {
      return false;
    }

    const browserName = this.detectionInfo.name;
    const version = this.parseVersion(this.detectionInfo.version);

    if (browserName === 'ie') {
      return true;
    }

    const futureMinVersion = FUTURE_MIN_VERSIONS[browserName];
    if (futureMinVersion && version < futureMinVersion) {
      return true;
    }

    return false;
  }

  getBrowserDisplayName(): string {
    if (!this.detectionInfo) {
      return 'Unknown Browser';
    }

    const nameMap = {
      chrome: 'Google Chrome',
      firefox: 'Mozilla Firefox',
      safari: 'Safari',
      edge: 'Microsoft Edge',
      'edge-chromium': 'Microsoft Edge',
      opera: 'Opera',
      ie: 'Internet Explorer',
      ios: 'Safari',
    };

    const name = nameMap[this.detectionInfo.name] || this.detectionInfo.name;
    return `${name} ${this.detectionInfo.version}`;
  }

  getRequiredVersion(): string | null {
    if (!this.detectionInfo) {
      return null;
    }

    const browserName = this.detectionInfo.name;
    const requiredVersion = FUTURE_MIN_VERSIONS[browserName];

    if (requiredVersion) {
      return `${requiredVersion}+`;
    }

    return null;
  }

  private parseVersion(versionString: string): number {
    const match = versionString.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }
}
